import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import {
  ContactsContainerStyled,
  ContactsStyled,
  FontAwesomeIconStyled,
  InfoContainer,
  TypographyStyled,
} from './ContactsStandard.styles';
import { SocialNetworksStandard } from './SocialNetworks';

export const ContactsStandard = () => (
  <ContactsContainerStyled>
    <Box>
      <ContactsStyled>
        <FormattedMessage id="TRLT_UI-CONTACTS" />
      </ContactsStyled>

      <InfoContainer>
        <FontAwesomeIconStyled icon={faPhone} />
        <TypographyStyled id="standardPhoneNumber">
          <FormattedMessage id="TRLT_UI-PHONE_NUMBER_STANDARD" />
        </TypographyStyled>
      </InfoContainer>
      <InfoContainer>
        <FontAwesomeIconStyled icon={faLocationDot} />
        <TypographyStyled>
          <FormattedMessage id="TRLT_UI-ADRESSE_STANDARD" />
        </TypographyStyled>
      </InfoContainer>
    </Box>
    <SocialNetworksStandard />
  </ContactsContainerStyled>
);
